import { Component, h, Prop, Host } from "@stencil/core";

@Component({
	tag: "smart-features-list",
	styleUrl: "smart-features-list.scss",
	shadow: true,
})
export class SmartFeaturesList {
	@Prop() theme: "light" | "dark" = "light";

	render() {
		return (
			<Host part="features-list-element" class={`smart-features-list smart-features-list--${this.theme}`}>
				<ul class="smart-features-list__ul">
					<slot></slot>
				</ul>
			</Host>
		);
	}
}
